import React, { useState, useEffect } from "react"
import Select from 'react-select'
import { useLocation } from "@reach/router"

// import GBP from "../../images/currency/gbp.png"
// import EUR from "../../images/currency/eur.png"
// import AED from "../../images/currency/aed.png"
// import USD from "../../images/currency/usd.png"
// import YEN from "../../images/currency/yen.png"
// import HKD from "../../images/currency/hkd.png"
import { useGlobalState } from '../GlobalState/GlobalStateProvider';


export default function CurrConvertLayout(props) {

    const { currState, updateState } = useGlobalState();
    const { pathname } = useLocation();
    
    const [labelValue, setLabelValue] = useState({ value: 'GBP', label: '£ GBP' });

    //const [flagType, setflagType] = useState(GBP);

    let values = [
        { value: 'GBP', label: '£ GBP' }, 
        { value: 'EUR', label: '€ EUR' }, 
        { value: 'AED', label: 'د.إ AED' },
        { value: 'USD', label: '$ USD' },
        { value: 'MYR', label: 'RM MYR' },
        { value: 'SGD', label: '$ SGD' },
        { value: 'HKD', label: '$ HKD' },
        { value: 'TRY', label: '₺ TRY' },
        { value: 'CNY', label: '¥ CNY' },
    ]
    //let values = props.currncy_values? props.currncy_values: ['AED','GBP','EUR','USD','RUB','INR']
    /*if(typeof process.env?.GATSBY_CurrencyConverter !== undefined){
      values =  process.env.GATSBY_CurrencyConverter.split(',');
    }*/
    let currVal = values[0]
    const handleCurrencyConverter = event => {
        //set localstorage value
        updateState(event.value.trimStart());
        setLabelValue(event)
        // if (event.value.trimStart() === "EUR") { setflagType(EUR) }
        // if (event.value.trimStart() === "GBP") { setflagType(GBP) }
        // if (event.value.trimStart() === "AED") { setflagType(AED) }
        // if (event.value.trimStart() === "USD") { setflagType(USD) }
        // if (event.value.trimStart() === "HKD") { setflagType(HKD) }
        // if (event.value.trimStart() === "YEN") { setflagType(YEN) }

        if (typeof window !== 'undefined') {
            localStorage.setItem('currTo', event.value.trimStart());
            // props.parentCallback(event.value.trimStart())
            // updateState({ globalcurrency: event.value.trimStart() });
        }
    }

    if (typeof window !== 'undefined') {
        if (localStorage.getItem('currTo') != null) {
            currVal = localStorage.getItem('currTo')
            updateState(localStorage.getItem('currTo'));
        }
    }

    useEffect(() => {
        // if (currVal === "EUR") { setflagType(EUR) }
        // if (currVal === "GBP") { setflagType(GBP) }
        // if (currVal === "AED") { setflagType(AED) }
        // if (currVal === "USD") { setflagType(USD) }
        // if (currVal === "HKD") { setflagType(HKD) }
        // if (currVal === "YEN") { setflagType(YEN) }
        // alert(currVal)
        if(currVal){
            var curr_val = values.filter(item => item.value === currVal)
            setLabelValue(curr_val[0])
        }
    }, [currVal])

    useEffect(() => {
        if(pathname.indexOf('international-location') > 0){
            if(props.currency){
                //console.log("currency ==>", props.currency)
                updateState(props.currency.trimStart());
    
                var curr_val = values.filter(item => item.value === props.currency.trimStart())
                setLabelValue(curr_val[0])
    
                if (typeof window !== 'undefined') {
                    localStorage.setItem('currTo', props.currency.trimStart());
                }
            }
        } else{
            if (typeof window !== 'undefined') {
                localStorage.setItem('currTo', labelValue.value);
            }

            updateState(labelValue.value);
            var curr_val = values.filter(item => item.value === labelValue.value)
            setLabelValue(curr_val[0])

            
        }


    },[props.currency])

    //console.log("currVal ==>", currVal, labelValue)
    return (
        <div className={props?.outterClass}>
            {/* <img src={flagType} alt="" className="flag" />  */}
            
            <Select
                value={labelValue}
                defaultValue={labelValue}
                options={values}
                className="react-select"
                classNamePrefix="currency-select"
                onChange={handleCurrencyConverter}
                isSearchable={false}
                isClearable={false}
                placeholder={labelValue?.label}
                //menuIsOpen={true}
            />
        </div>
    )
}